import { render, staticRenderFns } from "./AdminStatistics.vue?vue&type=template&id=25dd8cb0&scoped=true&"
import script from "./AdminStatistics.vue?vue&type=script&lang=js&"
export * from "./AdminStatistics.vue?vue&type=script&lang=js&"
import style0 from "./AdminStatistics.vue?vue&type=style&index=0&id=25dd8cb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dd8cb0",
  null
  
)

export default component.exports